angular.module('natgeo').controller('Level5PlanScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'ScreenView', 
function Level5PlanScreen($scope, element, ScreenFactory, manager, container, ScreenView)
{
	var screen = ScreenFactory( 'level5_plan', element );
	
	screen.once('introBefore', function()
	{
		anim8.save('sprocketArmRotate', {
			keyframe: {
				'0': {
					rotate: 0
				},
				'20': {
					rotate: -20
				},
				'30': {
					rotate: -20
				},
				'60': {
					rotate: 20
				},
				'70': {
					rotate: 20
				},
				'90': {
					rotate: 0
				},
				'100': {
					rotate: 0
				}
			},
			initial: {
				origin: {x: 90, y: 90}
			}
		});
	});
	
	// The next screen is the splash screen
	$scope.next = function()
	{
		manager.transition('level5_build');
	};
	
	// The previous screen is the learn screen
	$scope.prev = function()
	{
		manager.transition('level5_learn');
	};
	
}]);